import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IAttachmentDto } from '@fdm/api-client';
import { NoteAttachmentApiService } from '../note-attachment-api.service';

@Component({
  selector: 'app-attachments',
  imports: [
    CommonModule,
    MatTableModule,
    MatCheckboxModule
  ],
  templateUrl: './attachments.component.html',
  styleUrl: './attachments.component.scss',
})
export class AttachmentsComponent { 
  @Input()
  public set attachments(values: IAttachmentDto[]) {
    this.dataSource.data = values ?? [];
  }

  private _api = inject(NoteAttachmentApiService);

  displayedColumns: string[] = [
    'description',
    'fileName',
    'preview',
    'download',
  ];

  dataSource = new MatTableDataSource<any>();


  download(blobname: string) {
    this._api.download(blobname).subscribe();
  }

  preview(blobname: string) {
    this._api.preview(blobname).subscribe();
  }
}
